module.exports = __webpack_public_path__ + "img/minus-logo.1f6293c4.svg";